<script>
	import { auth, logout, userRoleNames } from "../auth";
	import {authUrl} from '../const'
  import AsyncButton from "./AsyncButton.svelte";
	import UserPicture from "./UserPicture.svelte"

	let menuShown = false

	async function login() {
		// console.log('login redir to', `https://${authUrl}/login?d=${window.location.hostname}&r=${window.location.href}`)
		window.location = `https://${authUrl}/login?d=${window.location.hostname}&r=${window.location.href}`
		return new Promise((_resolve, _reject) => {})
	}

	function toggleMenu() {
		menuShown = !menuShown
	}
</script>

<div>
	{#if $auth && $auth.userInfo}
		<div class='userContainer' on:click={toggleMenu} class:facade={$auth.userInfo.facade}>
			<span>{$auth.username}</span>
			<UserPicture user={$auth.userInfo} />
		</div>
		{#if menuShown}
			
			<div class="userDropdown">
				{#if !$auth.userInfo.anon }
					<div class='info'><b>Email:</b> {$auth.userInfo.email}</div>
					<div class='info'><b>Roles:</b> {userRoleNames($auth.roles)}</div>
					<hr />
					<div class='bb'>
						<AsyncButton handler={logout}>Logout</AsyncButton>
					</div>
				{:else}
					<div class='bb'>
						<AsyncButton handler={login}>Login</AsyncButton>
						<!-- <button>Register</button> -->
					</div>
				{/if}
			</div>
		{/if}
	{/if}
</div>

<style>
	.userContainer {
		cursor: pointer;
		height: 100%;
		display: flex;
		justify-content: right;
		align-items: center;
		padding: 5px 8px;
		background-color: #596377;
	}

	.userContainer.facade {
		background-color: #9d230e;
	}

	.userDropdown {
		box-shadow: 1px 8px 8px 3px rgba(0,0,0,0.75);
		position: absolute;
		top: 35px;
		right: 4px;
		background-color: rgba(37, 37, 37, 1);
		border: 1px solid black;
		z-index: 100;
		pointer-events: all;
		font-size: 10pt;
	}

	.info {
		padding:4px;
		color:darkgrey;
	}

	.bb {
		padding:8px;
	}

	.bb > button:first-child {
		margin-bottom:8px;
	}

	button {
		text-align:center;
		font-size:10pt;
	}

	img {
		width: 24px;
		height: 24px;
		border: 1px solid gray;
		border-radius: 16px;
		background-color: white;
		margin-left: 4px;
	}

	span {
		margin-right:8px;
	}

	@media only screen and (max-width: 600px) {
			.userContainer {
				width: 100vw;

			}

			.userDropdown {
				top: 88px;
			}
	}
</style>
